// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3IWTv","disabled":"FileBtn_disabled__2qOaw","warn":"FileBtn_warn__2aOT7","fade":"FileBtn_fade__2x2sP"};